import React from "react";
import styled from "styled-components";
import Github from "./images/github.png";
import Facebook from "./images/facebook.png";
import Instagram from "./images/instagram.png";
import Linkedin from "./images/linkedin.png";

const socialPanelData = [
  {
    link: "https://github.com/sannnao",
    title: "to github",
    src: Github,
  },
  {
    link: "https://www.facebook.com/profile.php?id=100001634313768",
    title: "to facebook",
    src: Facebook,
  },
  {
    link: "https://www.instagram.com/stormyweather_hoho/",
    title: "to instagram",
    src: Instagram,
  },
  {
    link: "https://www.linkedin.com/in/alexander-piskun-0a2a13175/",
    title: "to linkedin",
    src: Linkedin,
  },
];

const List = styled.ul`
  display: flex;
  list-style: none;
  background-color: #fff;
  border-radius: 5px;
`;

const ImgSize = 30;

const Item = styled.li`
  width: ${ImgSize}px;
  height: ${ImgSize}px;
  margin: 5px;
  background-color: inherit;

  &:hover {
    transform: scale(1.1);
    transition: 0.2s;
    opacity: 0.8;
  }

  &:active {
    transform: scale(0.9);
  }
`;

const Link = styled.a`
  display: inline-block;
  width: 100%;
  height: 100%;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
`;

export const SocialPanel = () => {
  return (
    <List>
      {socialPanelData.map(({ link, title, src }, i) => {
        return (
          <Item key={i}>
            <Link href={link} title={title} target="_blank">
              <Img src={src} alt={title} width={ImgSize} height={ImgSize} />
            </Link>
          </Item>
        );
      })}
    </List>
  );
};
